<template>
  <div>
    <BaseListPage
      headline="lang_SERVICE_CENTER_CAPTION_INSIGHTS"
      :context="context"
      :alvqa="alvqa"
      :stickyHeader="true"
    >
      <!-- No additional filter -->
      <template v-slot:filter></template>

      <!-- DATA TABLE COMPONENT -->
      <template v-slot:dataTable>
        <BaseDataTableList 
          :headers="headers"
          :context="context"
          :alvqa="alvqa"
          :hasServerSideSorting="false"
          readOnlyGhostTdSpan="1"
          :skipInitialFetch="true"
          :stickyTopSlot="true"
        >
          <!-- TOPSLOT: minimal -->
          <template v-slot:topSlot><InsightsTopSlot /></template>

          <!-- DATA TABLE CONTENT: columns -->
          <template v-slot:body="{ item }">
            <ExpandIcon 
              :isExpanded="item.isExpanded" 
              :alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
            />
            <td 
              class="no_ellipsis"
              :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-publish-date'"
            >
              {{ formatDate(item.item.publishDate) }}
            </td>
            <td class="ellipsis">
              <BaseTooltip>
                <template v-slot:text>{{ item.item.headline }}</template>
                <template v-slot:content>
                  <span 
                    :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-headline'"
                    :style="getHeadlineStyle(item.item.priority)"
                  >
                    {{ item.item.headline }}
                  </span>
                </template>
              </BaseTooltip>
            </td>
            <td 
              class="no_ellipsis"
              :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-domain'"
            >
              {{ getTranslatedDomain(item.item.domain) }}
            </td>
          </template>

          <!-- EXPAND: Read Only View -->
          <template v-slot:expandSlot="{ id }">
            <InsightsReadOnly :itemId="id" />
          </template>
        </BaseDataTableList>
      </template>
    </BaseListPage>
  </div>
</template>

<script>
import BaseDataTableList from '@/components/_base/BaseDataTableList'
import BaseListPage from '@/components/_base/BaseListPage'
import BaseTooltip from '@/components/_base/BaseTooltip'
import ExpandIcon from '@/components/_buttons/ExpandIcon'

import InsightsTopSlot from './InsightsTopSlot'
import InsightsReadOnly from './_readonly/InsightsReadOnly'
import { translateInsightDomain } from './_helpers/insightsDomain'

export default {
  name: 'InsightsList',
  components: {
    BaseListPage,
    BaseDataTableList,
    BaseTooltip,
    ExpandIcon,
    InsightsTopSlot,
    InsightsReadOnly
  },
  data() {
    return {
      context: "Insights",
      alvqa: "insights"
    }
  },
  computed: {
    headers() {
      return [
        {
          text: '', 
          value: 'data-table-expand',
          align: 'center', 
          width: "48px",
          sortable: false,
          class: 'text-no-wrap'
        },
        {
          text: this.$t('lang_GENERIC_CAPTION_DATE'), 
          value: 'publishDate',
          align: 'left', 
          width: "120px",
          sortable: true, 
          class: 'text-no-wrap'
        },
        {
          text: this.$t('lang_GENERIC_CAPTION_TITLE'), 
          value: 'headline',
          align: 'left', 
          sortable: true, 
          class: 'text-no-wrap'
        },
        {
          text: this.$t('lang_GENERIC_CAPTION_ALV_DOMAIN'), 
          value: 'domain',
          align: 'left', 
          width: "220px",
          sortable: true, 
          class: 'text-no-wrap'
        }
      ]
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return ''
      try {
        return this.$d(new Date(dateString), 'alvDateFormat')
      } catch (e) {
        return dateString
      }
    },
    
    getTranslatedDomain(domain) {
      return translateInsightDomain(domain, this.$t.bind(this))
    },
    
    getHeadlineStyle(priority) {
      if (priority === 'critical') {
        return 'color: #800020;' // Burgundy red for critical
      }
      return ''
    }
  },
  watch: {
    // Watch for language changes and refetch insights (same as Dashboard)
    '$i18n.locale'() {
      this.$nextTick(() => {
        this.$store.dispatch('fetchInsights', this.$i18n.locale)
      })
    }
  },
  async created() {
    // Reset any stale search term before loading
    this.$store.commit('setInsightsSearch', '')
    // Fetch insights on page load with current language
    await this.$store.dispatch('fetchInsights', this.$i18n.locale)
  }
}
</script>
